import React, { FC, PropsWithChildren } from "react";
import Logo from "components/common/Logo";

import * as Styled from "./styles";

const LoginTemplate: FC<PropsWithChildren> = ({ children }) => (
  <Styled.LoginTemplate>
    <Styled.Center>
      <Logo />
    </Styled.Center>
    <Styled.LoginWrapper>{children}</Styled.LoginWrapper>
  </Styled.LoginTemplate>
);

export default LoginTemplate;
